import { render, staticRenderFns } from "./Financial.vue?vue&type=template&id=24b59548&scoped=true"
import script from "./Financial.vue?vue&type=script&lang=js"
export * from "./Financial.vue?vue&type=script&lang=js"
import style0 from "./Financial.vue?vue&type=style&index=0&id=24b59548&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b59548",
  null
  
)

export default component.exports